export default "<app-heat-map\n    [catalogOpened]=\"data\"\n    [autoCenter]=\"true\"\n>\n</app-heat-map>\n"